const Header = () => (
	<header className="pageHeader">
		<h1 className="pageTitle">
			<span className="sr-only">Alphabetizer</span>
		</h1>
		<p className="pageSubtitle">
			Emojify your text to make it really :alphabet-yellow-p: :alphabet-yellow-o: :alphabet-yellow-p:
		</p>
	</header>
);

export default Header;
